import { render, staticRenderFns } from "./DeleteContactPerson.vue?vue&type=template&id=2dba4642&scoped=true"
import script from "./DeleteContactPerson.vue?vue&type=script&lang=ts"
export * from "./DeleteContactPerson.vue?vue&type=script&lang=ts"
import style0 from "./DeleteContactPerson.vue?vue&type=style&index=0&id=2dba4642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba4642",
  null
  
)

export default component.exports